<template>
  <div id="test">
    <div id="demo" v-if="hasData"></div>
    <div class="block-none" v-else>
      <img src="@/assets/images/train/img_none.png" class="img-none" alt="" />
      <div class="block-none-txt">暂无数据</div>
    </div>
  </div>
</template>

<script>
import Pdfh5 from 'pdfh5'
import 'pdfh5/css/pdfh5.css'
import { getAIFVPDF, queryPdf } from '@/api/aifv'
import withRouteTracking from '@/utils/withRouteTracking'
const UserProfile = {
  name: 'pdfView',
  data() {
    return {
      hasData: true,
      pdfh5: null,
      fileInfo: {}
    }
  },
  props: {
    projectId: {
      type: String,
      default: ''
    }
  },
  computed: {
    aifvReportId() {
      return this.$route.query.code || ''
    },
    operationId() {
      return this.$route.query.id || ''
    }
  },
  methods: {
    handleJumpPDF() {
      if (this.aifvReportId) {
        getAIFVPDF({fileId: this.aifvReportId}).then(res => {
          if (res && res.data) {
            window && window.sessionStorage.setItem('traceTitle', res.data.title + '-PDF预览')
            this.fileInfo = JSON.parse(JSON.stringify(res.data))
            this.pdfh5 = new Pdfh5('#demo', {
              pdfurl: this.fileInfo.url
            })
          }
        }).catch(err => {
          if (err.byteLength < 100) {
            this.hasData = false
            return false
          }
          this.pdfh5 = new Pdfh5('#demo', {
            data: err,
            scale: 5
          })
        })
      } else {
        queryPdf({operationId: this.operationId, isPDF: true}).then((res) => {
          if (res) {
            const url = window.URL.createObjectURL(new Blob([res], {
              type: 'application/pdf',
            }))
            window && window.sessionStorage.setItem('traceTitle', `${this.operationId}-PDF预览`)
            this.pdfh5 = new Pdfh5('#demo', {
              pdfurl: url
            })
          }
        }).catch(err => {
          if (err.byteLength < 100) {
            this.hasData = false
            return false
          }
          this.pdfh5 = new Pdfh5('#demo', {
            data: err,
            scale: 5
          })
        })
      }
    },
    handleGetPdf() {
      try {
        this.pdfh5 = new Pdfh5('#demo', {
          pdfurl: this.$route.query.pdfUrl
        })
      } catch (err) {
        console.log('handleJumpPDF err', err)
        if (err.byteLength < 100) {
          this.hasData = false
          return false
        }
        this.pdfh5 = new Pdfh5('#demo', {
          data: err,
          scale: 5
        })
      }
    }
  },
  mounted() {
    if (this.$route.query.pdfUrl) {
      this.handleGetPdf()
    } else {
      this.handleJumpPDF()
    }
  },
  beforeDestroy() {
    this.pdfh5 = null
  }
}
export default withRouteTracking(UserProfile)
</script>

<style lang="less" scoped>
#demo {
  width: 100vw;
  height: 100vh;
}
.block-none {
  padding-top: 240px;
  box-sizing: border-box;
  .img-none {
    width: 120px;
    height: 104px;
    margin-bottom: 12px;
    margin-left: 50%;
    transform: translateX(-50%);
  }
  .block-none-txt {
    font-size: 14px;
    color: #5b5f6a;
    line-height: 20px;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/AIFV/pdfView.vue